import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../default-settings-service.service';
import {ExcRestService} from 'exc-rest';
import {ExcListComponent, ExcListConfig} from 'exc-controls';
import {ExcTab} from 'exc-tab';
import {DealerDetailsComponent} from '../dealer-details/dealer-details.component';
import {AuditDetailsComponent} from '../audit-details/audit-details.component';
import {KanbanItemAction} from '../kanban-item/kanban-item.component';
import {ModalPlanningHqSettingsComponent} from '../modals/modal-planning-hq-settings/modal-planning-hq-settings.component';
import {ModalAuditCancelComponent} from '../modals/modal-audit-cancel/modal-audit-cancel.component';
import {ModalAuditPinChangedComponent} from '../modals/modal-audit-pin-changed/modal-audit-pin-changed.component';
import {ModalYesNoComponent} from '../modals/modal-yes-no/modal-yes-no.component';
import {ModalAuditExtendComponent} from '../modals/modal-audit-extend/modal-audit-extend.component';
import {AuditActionService} from '../audit-action-service.service';
import {ExcFilter, ExcFilterCondition, ExcSort, FilterSortService} from '../filter-sort-service.service';

@Component({
  selector: 'app-kanban',
  templateUrl: './kanban.component.html',
  styles: []
})
export class KanbanComponent extends ExcTranslation implements OnInit {

  @ViewChild('lane1') ctrlLane1: ExcListComponent;
  @ViewChild('lane2') ctrlLane2: ExcListComponent;
  @ViewChild('lane3') ctrlLane3: ExcListComponent;
  @ViewChild('lane4') ctrlLane4: ExcListComponent;
  selectedYear = (new Date()).getFullYear();
  selectedMonth = (new Date()).getMonth() + 1;
  popupData = {Year: (new Date()).getFullYear(), Month: (new Date()).getMonth() + 1};
  data  = {Lane1: [], Lane2: [], Lane3: [], Lane4: []};
  listConfig1: ExcListConfig = new ExcListConfig();
  listConfig2: ExcListConfig = new ExcListConfig();
  listConfig3: ExcListConfig = new ExcListConfig();
  listConfig4: ExcListConfig = new ExcListConfig();
  searchList1: string = null;
  searchList2: string = null;
  searchList3: string = null;
  searchList4: string = null;
  optionsMonth: any[] = [];
  optionsYear: any[] = [];
  selected = {Lane: 1, Item: null};
  @ViewChild('popup') popup;
  @ViewChild('filterLane1') filterLane1;
  lstSortLane1: ExcSort[] = [];
  lstFilterLane1: ExcFilter[] = [];
  constructor(private excDss: DefaultSettingsService, private excRest: ExcRestService, private auditAction: AuditActionService, private excFss: FilterSortService) {
    super();
    const _self = this;
    for (let i = 1; i <= 12; i++) {
      _self.optionsMonth.push({text: i, value: i});
    }
    for (let i = -3; i <= 3; i++) {
      _self.optionsYear.push({text: (new Date()).getFullYear() + i, value: (new Date()).getFullYear() + i});
    }
    _self.listConfig1.OnFilterClick = (event?) => _self.filterLane1.toggle(event);
    _self.listConfig1.OnFilter = () => {
    };

    _self.listConfig1.selectionMode = 'none';
    _self.listConfig1.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.listConfig1.OnSearch = function (searchValue, event?) {
      _self.searchList1 = searchValue || '';
      _self.loadList(1);
    };
    _self.listConfig1.OnPageChanged = (pageNo, event1) => {
      _self.listConfig1.paging.pagingPage = pageNo;
      _self.loadList(1);
    };
    _self.listConfig1.OnRefresh = () => {
      _self.loadList(1);
    };
    _self.listConfig1.OnSelectionChanged = (selectedItems, event?) => {
      _self.selected.Lane = 1;
      _self.selected.Item = selectedItems[0];
      _self.ctrlLane2.deselectAll();
      _self.ctrlLane3.deselectAll();
      _self.ctrlLane4.deselectAll();
    };

    _self.listConfig2.selectionMode = 'none';

    _self.listConfig2.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.listConfig2.OnSearch = function (searchValue, event?) {
      _self.searchList2 = searchValue || '';
      _self.loadList(2);
    };
    _self.listConfig2.OnPageChanged = (pageNo, event1) => {
      _self.listConfig2.paging.pagingPage = pageNo;
      _self.loadList(2);
    };
    _self.listConfig2.OnRefresh = () => {
      _self.loadList(2);
    };
    _self.listConfig2.OnSelectionChanged = (selectedItems, event?) => {
      _self.selected.Lane = 2;
      _self.selected.Item = selectedItems[0];
      _self.ctrlLane1.deselectAll();
      _self.ctrlLane3.deselectAll();
      _self.ctrlLane4.deselectAll();
    };

    _self.listConfig3.selectionMode = 'none';

    _self.listConfig3.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.listConfig3.OnSearch = function (searchValue, event?) {
      _self.searchList3 = searchValue || '';
      _self.loadList(3);
    };
    _self.listConfig3.OnPageChanged = (pageNo, event1) => {
      _self.listConfig3.paging.pagingPage = pageNo;
      _self.loadList(3);
    };
    _self.listConfig3.OnRefresh = () => {
      _self.loadList(3);
    };
    _self.listConfig3.OnSelectionChanged = (selectedItems, event?) => {
      _self.selected.Lane = 3;
      _self.selected.Item = selectedItems[0];
      _self.ctrlLane2.deselectAll();
      _self.ctrlLane1.deselectAll();
      _self.ctrlLane4.deselectAll();
    };

    _self.listConfig4.selectionMode = 'none';

    _self.listConfig4.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.listConfig4.OnSearch = function (searchValue, event?) {
      _self.searchList4 = searchValue || '';
      _self.loadList(4);
    };
    _self.listConfig4.OnPageChanged = (pageNo, event1) => {
      _self.listConfig4.paging.pagingPage = pageNo;
      _self.loadList(4);
    };
    _self.listConfig4.OnRefresh = () => {
      _self.loadList(4);
    };
    _self.listConfig4.OnSelectionChanged = (selectedItems, event?) => {
      _self.selected.Lane = 4;
      _self.selected.Item = selectedItems[0];
      _self.ctrlLane2.deselectAll();
      _self.ctrlLane3.deselectAll();
      _self.ctrlLane1.deselectAll();
    };
    _self.lstFilterLane1 =  [
      new ExcFilter(1, '', 'AuditIsToday', new ExcFilterCondition('=', true), 'fltOpen', 'Globals.DueToday', false)
    ];
    _self.lstSortLane1 = [
        new ExcSort('DealerLevel1', 0, this.excDss.getLabel('DealerLevel1'), 0)
      , new ExcSort('DealerLevel2', 0, this.excDss.getLabel('DealerLevel2'), 0)
      , new ExcSort('DealerLevel3', 0, this.excDss.getLabel('DealerLevel3'), 0)
      , new ExcSort('DealerName', 0, this.excDss.getLabel('DealerName'), 0)
    ];
    for (const x of _self.lstSortLane1) {
      if (x !== undefined) {
        x.Container = _self.lstSortLane1;
      }
    }
  }
  applyFilterLane1() {
    this.filterLane1.hide();
    this.loadList(1);
  }

  resetFilterLane1() {
    this.filterLane1.hide();
    this.excFss.ResetFilter(this.lstFilterLane1, this.lstSortLane1);
    this.loadList(1);
  }
  openAudit(x) {

  }
  handleAction(event: KanbanItemAction) {
    const _self = this;
    switch (event.Action) {
      case 'details':
       this.auditAction.Open(event.Item.AuditID, event.Item);
        break;
      case 'comment':
        this.auditAction.SelfcheckComment(event.Item.AuditID, event.Item['AuditScComment']).subscribe(ret => {
          if (ret.Result === true) {
            Object.assign(event.Item, ret.Data);
          }
        });
        break;
      case 'cancel':
        this.auditAction.Cancel(event.Item.AuditID).subscribe(ret => { if (ret.Result === true) { _self.initialLoad(); }});
        break;
      case 'pin':
        this.auditAction.ChangePin(event.Item.AuditID).subscribe(r => {});
        break;
      case 'extend':
        this.auditAction.Extend(event.Item.AuditID).subscribe(ret => { if (ret.Result === true) { _self.initialLoad(); }});
        break;
      case 'resend':
        this.auditAction.ResendCode(event.Item.AuditID, event.Item['DealerMail']).subscribe(ret => {});
        break;
      case 'remoteclose':
        this.auditAction.RemoteClose(event.Item.AuditID, event.Item['AuditItemsDone'], event.Item['AuditItemsTotal']).subscribe(ret => { _self.loadList(2); });
        break;
      case 'escalate':
        this.auditAction.Escalate(event.Item.AuditID).subscribe(ret => { _self.loadList(3); _self.loadList(4); });
        break;
      case 'archive':
        this.auditAction.Archive(event.Item.AuditID).subscribe(ret => { _self.loadList(3); _self.loadList(4); });
        break;
      case 'escalationaction':
        // this.auditAction.EscalationAction(event.Item.AuditID).subscribe(ret => { _self.initialLoad(); });
        break;
        // RP-796 - übernahme der Teilergebnisse
      case 'adopt':
        this.auditAction.adoptResult(event.Item.AuditID, event.Item['AuditItemsDone'], event.Item['AuditItemsTotal']).subscribe(ret => { _self.loadList(2); });
        break;
      case 'reopen':
        this.auditAction.Reopen(event.Item.AuditID).subscribe(ret => { _self.loadList(2); _self.loadList(3); });
        break;
      default:
        break;
    }
  }
  showPopup(e) {
    this.popupData.Year = this.selectedYear;
    this.popupData.Month = this.selectedMonth;
    this.popup.show(e);
  }
  cancelPopup(e) {
    this.popup.hide(e);
  }
  applyPopup(e) {
    this.popup.hide(e);
    this.selectedYear = this.popupData.Year;
    this.selectedMonth = this.popupData.Month;
    this.initialLoad();
  }

  getTimeframeTip() {
    const month = this.selectedMonth.toString().padStart(3, '0');
    return month.substring(1, 3) + '/' + this.selectedYear.toString();
  }
  initialLoad() {
    const _self = this;
    _self.listConfig1.isLoading = true;
    _self.listConfig2.isLoading = true;
    _self.listConfig3.isLoading = true;
    _self.listConfig4.isLoading = true;
    const url = _self.excRest.computeUrl('KanbanR_Summary', {AuditYear: _self.selectedYear, AuditMonth: _self.selectedMonth});
    _self.excRest.get(url, {}).subscribe(ret => {
      _self.data = ret.data;
      _self.listConfig1.paging = ret.paging.Lane1;
      _self.listConfig2.paging = ret.paging.Lane2;
      _self.listConfig3.paging = ret.paging.Lane3;
      _self.listConfig4.paging = ret.paging.Lane4;
      _self.listConfig1.isLoading = false;
      _self.listConfig2.isLoading = false;
      _self.listConfig3.isLoading = false;
      _self.listConfig4.isLoading = false;
    });
  }
  loadList(nr) {
    const _self = this;
    _self['listConfig' + nr].isLoading = true;
    const fts = _self['searchList' + nr];
    let mi = _self['listConfig' + nr].GetMetaInfo();

    if (nr === 1) {
      mi =  this.excFss.ApplyFilter(mi, this['lstFilterLane' + nr], this['lstSortLane' + nr]);
    }

    const url = _self.excRest.computeUrl('KanbanR_ListLane' + nr, {AuditYear: _self.selectedYear, AuditMonth: _self.selectedMonth, fts: fts});
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret === null) {
        _self.data['Lane' + nr] = [];
      } else {
        _self.data['Lane' + nr] = ret.data;
        _self['listConfig' + nr].paging = ret.paging;
      }
      _self['listConfig' + nr].isLoading = false;
    });
  }
  ngOnInit() {
    this.initialLoad();
  }
}
